export const GLOBAL_ACTYPE_TYPE = {
    LOADER:'loader'
  };
  